export default "__VITE_ASSET__kZLOKC_s__"